import { render } from "./DiscordIcon.vue?vue&type=template&id=0a4353df"
const script = {}
script.render = render

export default script